import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MemberService } from '@services/member.service';
import { Router, ActivatedRoute } from '@angular/router';
import {fadeInRightOnEnterAnimation,fadeInRightAnimation} from 'angular-animations';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.sass'],
  animations:[
    fadeInRightAnimation(),
    fadeInRightOnEnterAnimation({translate:'500px'})
  ]
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  btn_process=false;
  error: any = { "email": "", "password": "", "firstName": "", "lastName": "", "confirmPassword": "" };
  pass_type=false;
  cpass_type=false;
  site_name="";
  constructor(private route: ActivatedRoute,private _memberService: MemberService,private fb: FormBuilder,private router: Router, public _global: GlobalService) {
    this.registerForm = this.fb.group({
      firstName: [],
      lastName: [],
      email: [],
      password: [],
      confirmPassword:[]
    });
    this.site_name = this._global.SITE_NAME;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log("Route Params", params);
      if (params['email']) {
        this.registerForm.get("email").setValue(params['email']);
      }
    });
  }
public register() {
  this.error = { "email": "", "password": "", "firstName": "", "lastName": "", "confirmPassword": "" };
    this.btn_process=true;
    let r = this.registerForm.value;
    r=this._global.paramsRemoveNull(r);
    this._memberService.register(r).subscribe(
      data => {
        if (data["status"] == 1) {
          localStorage.removeItem(this._global.SESSION_KEY);
          localStorage.setItem(this._global.SESSION_KEY, JSON.stringify(data["response"]));
          this.router.navigate(['']);
        }
        else {
          this.btn_process=false;
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
          this._global.showMessage({ severity: 'warning', message: this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
}

